<template lang="pug">
#nova-analise-certificacao
    BaseHeader(
        :titulo='$t("mensagens.certificado.novaAnaCertificacoes")',
        :exibeBotao='false',
        :voltarPara='true'
    )

    .view-container.margen-bottom-pages
        .bloco-lista-certificacoes-ativas
            BlocoListarAtivasCertificao(
                @emitIdsCertificacaoTipo='idsCertificacaoTipo'
            )

        .bloco-inserir-dados-certificacao
            BlocoInserirManualmenteCertificacao(
                @adicionarCertificacaoNaoEnviada='adicionarCertificacaoNaoEnviadaManual',
                :tiposCertificaoesSelecionadas='tiposCertificaoesSelecionadas',
            )

            BlocoInserirPlanilhaCertificacao(
                :tiposCertificaoesSelecionadas='tiposCertificaoesSelecionadas',
                @atualizar-tabela-certificacao-lote='handlerEventoAtualizarTabela'
                @adicionarCertificacaoNaoEnviadaPlanilha='adicionarCertificacaoNaoEnviadaPlanilha'
            )

        .bloco-tabela-territorio-nao-enviado
            BlocoTabelaNaoEnviadasCertificacao(
                :atualizar='atualizarTabelaCertificacaoLote'
                ref='tabelaTerritorio'
            )

    ModalCertificacoesExistentes(
        v-if='!carregandoTabela',
        :mostrar='exibirModalCertificacoesExistentes',
        :lista='carsListComCertificacao',
        @fechar='fecharModalCertificacoesExistentes'
    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BlocoListarAtivasCertificao from '@/components/certificacao/BlocoListarAtivasCertificao.vue';
import BlocoInserirManualmenteCertificacao from '@/components/certificacao/BlocoInserirManualmenteCertificacao.vue';
import BlocoInserirPlanilhaCertificacao from '@/components/certificacao/BlocoInserirViaPlanilhaCertificacao.vue';
import BlocoTabelaNaoEnviadasCertificacao from '@/components/certificacao/TabelaNaoEnviadasCertificacao.vue';
import CertificacaoService from '@/services/CertificacaoService';
import CarUtils from '@/utils/CarUtils';
import ModalCertificacoesExistentes from '@/components/ModalCertificacoesExistentes.vue';

export default {
    name: 'InserirCertificacao',
    components: {
        BaseHeader,
        BlocoListarAtivasCertificao,
        BlocoInserirManualmenteCertificacao,
        BlocoInserirPlanilhaCertificacao,
        BlocoTabelaNaoEnviadasCertificacao,
        ModalCertificacoesExistentes
    },
    data() {
        return {
            dataTerritoriosNaoEnviados: [],
            removendoTerritoriosCertificados: false,
            territoriosSelecionados: [],
            certificacao: {
                idsTerritorio: [],
                idsCertificacaoTipo: [],
                nomeTerritorioCar: []
            },
            exibirModalCertificacoesExistentes: false,
            params: {
                page: 0,
                size: 10,
                sort: 'dataCadastro',
                por: 'desc'
            },
            filtro: {
                pesquisaFiltro: '',
                estadoId: [],
                territoriosAnalisados: false,
                areaPlantadaElegivel: false
            },
            certificacoesLista: [],
            carregandoTabela: false,
            carsListComCertificacao: [],
            carList: [],
            atualizarTabelaCertificacaoLote: {},
            tiposCertificaoesSelecionadas: []
        };
    },

    methods: {
        adicionarCertificacaoNaoEnviadaManual(territorio) {
            if (typeof territorio === 'string') {
                this.dataTerritoriosNaoEnviados.push({
                    id: null,
                    nome: territorio,
                    cars: [],
                    representantes: []
                });

                return;
            }

            const found = this.dataTerritoriosNaoEnviados.find(
                element => element.id === territorio.id
            );

            if (found) {
                this.$notify.error({
                    message: this.$t('mensagens.certificado.territorioNaLista')
                });
            } else {
                this.$refs.tabelaTerritorio.carregarTabela(true);
                this.dataTerritoriosNaoEnviados.push(territorio);
            }
            setTimeout(() => {
                this.$refs.tabelaTerritorio.carregarTabela(false);
            }, 500);
        },

        adicionarCertificacaoNaoEnviadaPlanilha(dadosPlanilha) {
            this.dataTerritoriosNaoEnviados = [];
            Object.keys(dadosPlanilha.itens).forEach(territorio => {
                this.dataTerritoriosNaoEnviados.push(
                    dadosPlanilha.itens[territorio]
                );
            });
        },

        removerTerritorioLote(idsTerritorios) {
            this.territoriosSelecionados = idsTerritorios;
        },

        async removerTerritorio() {
            if (this.territoriosSelecionados.length === 0) {
                this.$notify.warning(
                    this.$t('mensagens.certificado.nenhumTerritorioParaRemover')
                );
            } else {
                await this.$messageBox.confirm(
                    this.territoriosSelecionados.length === 1
                        ? this.$t('mensagens.certificado.desejaRemover')
                        : this.$t('mensagens.certificado.desejaRemoverPlural'),
                    'Aviso',
                    {
                        confirmButtonText: this.$t('mensagens.certificado.sim'),
                        cancelButtonText: this.$t(
                            'mensagens.certificado.cancelar'
                        ),
                        type: 'warning'
                    }
                );
                try {
                    this.$nextTick(() => {
                        this.$refs.tabelaTerritorio.removerTerritorio(
                            this.territoriosSelecionados
                        );
                    });
                } catch (error) {
                    this.$notify.error({
                        message: 'Erro na requisição de remover o terrirório.'
                    });
                }
                this.$notify.success(
                    this.territoriosSelecionados.length === 1
                        ? this.$t('mensagens.certificado.terrRemovido')
                        : this.$t('mensagens.certificado.terrRemovidos')
                );
            }
        },

        idsCertificacaoTipo(idsCertificacaoTipo) {
            this.tiposCertificaoesSelecionadas = idsCertificacaoTipo.idsTipo;
        },

        realizarAnalise() {
            if (!this.dataTerritoriosNaoEnviados.length) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.certificado.necessarioPeloMenosUmaCert'
                    )
                });
                return;
            }

            if (!this.certificacao.idsCertificacaoTipo.length) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.certificado.necessarioPeloMenosUmaCert'
                    )
                });
                return;
            }

            this.certificacao.idsTerritorio = this.dataTerritoriosNaoEnviados
                .map(obj => (CarUtils.isCar(obj.nome) ? obj.nome : obj.id))
                .filter(item => item !== null && item !== undefined);

            this.certificacao.nomeTerritorioCar = [];
            this.dataTerritoriosNaoEnviados.forEach(obj => {
                if (obj.id === undefined) {
                    this.certificacao.nomeTerritorioCar.push({
                        nomeTerritorio: obj.nome,
                        codigoCAR: obj.cars.length ? obj.cars[0].codigo : null,
                        nomeRepresentante:
                            obj.representanteNovo !== undefined &&
                            obj.representanteNovo.length
                                ? obj.representanteNovo[0].nomeRazaoSocial
                                : null,
                        cpfCnpj:
                            obj.representanteNovo !== undefined &&
                            obj.representanteNovo.length
                                ? obj.representanteNovo[0].cpfCnpjDecrypt
                                : null
                    });
                }
            });
            this.buscarCertificacoes();
        },

        verificaCertificacoesExistentes(listaDeCarsByApi) {
            this.dataTerritoriosNaoEnviados.map(territorio =>
                territorio.cars.map(car => this.carsList.push(car.codigo))
            );

            listaDeCarsByApi.forEach(carByApi => {
                carByApi.cars.map(car => {
                    if (
                        this.carsList.includes(car.codigo) &&
                        carByApi.certificacaoStatus.some(
                            el => el.status === true
                        )
                    ) {
                        this.carsListComCertificacao.push(carByApi);
                    }
                });
            });

            this.carsListComCertificacao = this.removeItemsDuplicadosPorId(
                this.carsListComCertificacao
            );

            if (this.carsListComCertificacao.length > 0) {
                this.exibirModalCertificacoesExistentes = true;
            } else {
                this.inserirCertificacaoTerritorio();
            }
        },

        removeItemsDuplicadosPorId(arr) {
            return arr.reduce((acc, current) => {
                if (!acc.some(item => item.id === current.id)) {
                    acc.push(current);
                }
                return acc;
            }, []);
        },

        async buscarCertificacoes() {
            this.carregandoTabela = true;
            this.carsList = [];
            try {
                const { data } = await CertificacaoService.buscarCertificacoes(
                    this.filtro,
                    this.params,
                    true
                );
                this.certificacoesLista = data.itens;
                this.verificaCertificacoesExistentes(data.itens);
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.certificado.nPossivelBuscarTerr'
                    )
                });
            }
            this.carregandoTabela = false;
        },

        fecharModalCertificacoesExistentes(confirma) {
            this.exibirModalCertificacoesExistentes = false;
            if (confirma) {
                this.inserirCertificacaoTerritorio();
            }
        },

        inserirCertificacaoTerritorio() {
            CertificacaoService.InserirCertificacaoTerritorio({
                idTerritorio: this.certificacao.idsTerritorio,
                idCertificacaoTipo: this.certificacao.idsCertificacaoTipo,
                nomeTerritorioCar: this.certificacao.nomeTerritorioCar
            }).catch(error => {
                // eslint-disable-next-line no-console
                console.error(error);
            });
            this.$router.push({ name: 'Certificacao' });
        },

        handlerEventoAtualizarTabela(value) {
          this.atualizarTabelaCertificacaoLote = value;
        }
    }
};
</script>

<style lang="scss">
#nova-analise-certificacao {
    .bloco-lista-certificacoes-ativas,
    .bloco-inserir-dados-certificacao,
    .bloco-listagem-territorio-contrato,
    .bloco-view-container-down,
    .bloco-tabela-territorio-nao-enviado {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
    }

    .bloco-inserir-dados-certificacao {
        justify-content: space-between;
        gap: 15px;
        width: 100%;
        margin-top: 20px;
        flex-direction: row;

        .el-card__body {
            align-items: stretch;
        }
    }

    .bloco-lista-certificacoes-ativas {
        justify-content: space-between;
        gap: 4px;

        .el-card__body {
            align-items: stretch;
        }
    }

    .bloco-view-container-down {
        gap: 15px;
        width: 100%;
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;

        .bloco-view-container-down__conteudo__remove-item {
            el-link {
                color: var(--hover-danger);
            }
        }

        .bloco-view-container-down__conteudo__buttons {
            display: flex;
            gap: 10px;
        }
    }

    footer {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .botao-certificacao__remover,
        .botao-certificacao__enviar-para-analise {
            margin-top: 16px;

            .lyra-icon.lyra-grafico ::after {
                color: white;
            }

            #adicionar-analise {
                span {
                    margin-left: 5px;
                }
            }
        }
    }
}
</style>
